import { render } from "./users-tab.vue?vue&type=template&id=17f7f11e&scoped=true"
import script from "./users-tab.vue?vue&type=script&lang=js"
export * from "./users-tab.vue?vue&type=script&lang=js"

import "./users-tab.vue?vue&type=style&index=0&id=17f7f11e&scoped=true&lang=css"

import exportComponent from "/Users/apple/Documents/Full Stack Projects/elghoneimy-service-fullstack/source/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f7f11e"]])

export default __exports__